var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRestartAlt(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 16,
    viewBox: "0 0 21 16",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.969 3.894c.358 0 .61.168.779.42l1.978 3.264a.8.8 0 010 .864.92.92 0 01-.779.42h-1.03c.335 3.011 3.009 5.41 6.188 5.41 1.2 0 2.4-.335 3.432-1.03a.912.912 0 011.2.274c.252.42.169.947-.252 1.2C13.2 15.578 11.642 16 10.105 16c-4.126 0-7.557-3.095-8-7.136L.99 8.863c-.526 0-.863-.359-.863-.864 0-.168.084-.336.168-.505.169-.253 1.2-2.063 1.895-3.18a.92.92 0 01.779-.42zM10.105 0c4.127 0 7.558 3.095 8 7.136h1.116c.505 0 .863.359.863.843 0 .168-.085.337-.169.505-.168.254-1.2 2.064-1.894 3.18a.92.92 0 01-.78.42.895.895 0 01-.778-.42L14.484 8.4a.8.8 0 010-.863.92.92 0 01.78-.421h1.03c-.336-3.01-3.01-5.41-6.189-5.41-1.2 0-2.4.336-3.431 1.03-.422.253-.948.17-1.2-.252-.253-.42-.169-.947.252-1.2C7.011.422 8.568 0 10.106 0z"
  })));
}

export default SvgRestartAlt;